import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=2d2a737c&scoped=true&"
import script from "./RequestDetails.vue?vue&type=script&lang=js&"
export * from "./RequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./RequestDetails.vue?vue&type=style&index=0&id=2d2a737c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a737c",
  null
  
)

export default component.exports